export const SELECT_PRODUCTS = 'SELECT_PRODUCTS';
export const SELECT_PRODUCT = 'SELECT_PRODUCT';
export const TOGGLE_SUBSCRIPTION = 'TOGGLE_SUBSCRIPTION';
export const TOGGLE_BOOKMARK = 'TOGGLE_BOOKMARK';
export const TOGGLE_ALARM = 'TOGGLE_ALARM';

export const CREATE_TALK = 'CREATE_TALK';
export const CREATE_COMMENT = 'CREATE_COMMENT';
export const TOGGLE_LIKE_TALK = 'TOGGLE_LIKE_TALK';
export const TOGGLE_LIKE_COMMENT = 'TOGGLE_LIKE_COMMENT';
export const DELETE_TALK = 'DELETE_TALK';
export const DELETE_COMMENT = 'DELETE_COMMENT';

export const SELECT_PACKAGES = 'SELECT_PACKAGES';

export const SELECT_TALKS = 'SELECT_TALKS';
export const SELECT_COMMENTS = 'SELECT_COMMENTS';

export const SELECT_REVIEWS = 'SELECT_REVIEWS';

export const SELECT_PURCHASES = 'SELECT_PURCHASES';
